module.exports = __webpack_public_path__ + "0fff379a6cb248cae36dcbc617315059.jpg";